import React from 'react';

import './banner.styles.scss';

export const Banner = ({handleClick}) => {
    return (
        <section className="banner">
            <div className="logo-wrapper">
                <a href="https://crowdriff.com" className="logo"><img src="https://crowdriffstg.wpengine.com/wp-content/uploads/crowdriff-logo-all-white.svg" alt="CrowdRiff"/></a>
            </div>
            <div className="container">
                <div className="content-wrapper">
                    <h1>Travel & Tourism <span>Community Stories</span></h1>
                    <p>The Community Stories Hub is a curated stream of content to equip you with the insights and knowledge of what other travel & tourism brands did to effectively respond to the COVID-19 pandemic.</p>
                    <button className="btn btn-hollow white" onClick={handleClick}>Submit a Link</button>
                </div>
            </div>
        </section>
    )
}